import { Injectable } from '@angular/core';
import { ApiService } from '@app/core/services/api.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  private readonly tasksCache = new Map<string, Promise<any[]>>();

  constructor(private readonly apiService: ApiService) { }

  public getPendingTasksByEmail(email: string): Promise<any[]> {
    if (this.tasksCache.has(email)) {
      return this.tasksCache.get(email);
    }

    const promise = new Promise<any[]>((resolve, reject) => {
      this.apiService.get(`User/${email}/Tasks`).subscribe({
        next: (res: any[]) => resolve(res),
        error: (error) => {
          this.tasksCache.delete(email);
          reject(error);
        }
      });
    });

    this.tasksCache.set(email, promise);
    return promise;
  }

  public clearTasksCache(): void {
    this.tasksCache.clear();
  }
}
